import React from 'react';
import PropTypes from 'prop-types';

import Config from '@/config';

const EmbedCode = ({ annuity_quoter }) => {
  return (
    <div>
      <p style={{ fontFamily: 'monospace', lineHeight: '1.8em', fontSize: '12px' }}>
        {`<link href='${Config.AQ_URL}@css/reset.css' rel='stylesheet' type='text/css'>`}
        <br />
        {"<script type='text/javascript'>"}
        <br />
        <span
          style={{ marginLeft: '20px' }}
        >{`window.HEXURE_AQ_CONFIG = { id: '${annuity_quoter.token}' };`}</span>
        <br />
        {'</script>'}
        <br />
        {"<div id='hexure-annuities-quoter'></div>"}
        <br />
        {`<script type='text/javascript' src='${Config.AQ_URL}js/annuities_quoter.widget.js'></script>`}
      </p>
    </div>
  );
};

EmbedCode.propTypes = {
  annuity_quoter: PropTypes.object
};

export default EmbedCode;
